function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import pathOr from 'ramda/src/pathOr';
import i18n from 'invision-core/src/components/i18n/i18n';
import MetadataActions from 'invision-core/src/components/metadata/metadata.actions';
import MetadataConstants from 'invision-core/src/components/metadata/metadata.constants';
import MetadataSelectors from 'invision-core/src/components/metadata/metadata.selectors';
import { UserSecurityAttributesSelector } from 'invision-core/src/components/session/session.selectors';
import { IsDbss } from 'invision-core/src/components/session/businessunit.selectors';
import CustomerLocaleKeys from '../../../../../locales/keys';
import { HasAdminOrderingAccessSelector, HasOrderingAccessSelector } from '../../../../../reducers/selectors/permissions.selectors';
import { CurrentCustomerSelector, CurrentCustomerIdSelector, IsPIIDataAccessEnabledSelector } from '../../../../../reducers/selectors/customer.selectors';
import { CustomerActiveProductsDisplayItemsSelector, IsFetchingActiveProductsSelector } from '../../../../../reducers/selectors/customer.products.selectors';
import { CREATE_PRODUCTS_ORDER_STATE_NAME } from '../../../../../reducers/constants/products.wizard.constants';
import { BILLER_RULE_INSTANCE_TYPE } from '../../../../../customercare.constants';
import { PRODUCT_CLASSIFICATIONS } from 'invision-core/src/constants/product.constants';
import { searchOrders } from '../../../../../reducers/actions/order.history.actions';
import { stateGo } from 'redux-ui-router';
var ACTIVE_PRODUCT_IMAGE_WIDTH = 60;
var ActiveProductsController = /*#__PURE__*/function () {
  function ActiveProductsController($ngRedux, $state, $timeout) {
    _classCallCheck(this, ActiveProductsController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      $state: $state,
      $timeout: $timeout,
      customerCareKeys: CustomerLocaleKeys,
      discountToolTipTemplate: require('../../../../shared/tooltipTemplates/discount.tooltip.html'),
      selectedItems: []
    });
  }
  return _createClass(ActiveProductsController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      this.productImageWidth = ACTIVE_PRODUCT_IMAGE_WIDTH;
      this.addProductAction = {
        id: 'NEW_PRODUCT_ORDER',
        title: i18n.translate(CustomerLocaleKeys.NEW_PRODUCT_ORDER),
        callback: function callback() {
          _this.goToAddProductWizard();
        },
        shouldShow: function shouldShow() {
          return _this.state.hasAdminOrderingAccess && _this.state.isPIIDataAccessEnabled;
        }
      };
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          activeProducts: CustomerActiveProductsDisplayItemsSelector(store),
          businessUnitIsDbss: IsDbss(store),
          currentCustomer: CurrentCustomerSelector(store),
          currentCustomerId: CurrentCustomerIdSelector(store),
          hasOrderingAccess: HasOrderingAccessSelector(store),
          hasAdminOrderingAccess: HasAdminOrderingAccessSelector(store),
          isFetchingActiveProducts: IsFetchingActiveProductsSelector(store),
          isPIIDataAccessEnabled: IsPIIDataAccessEnabledSelector(store),
          productClassifications: MetadataSelectors.codes.MetadataCodeTypeSelector(MetadataConstants.codes.ProductClassification, store),
          productClassificationsLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.ProductClassification, store),
          userSecurityAttributes: UserSecurityAttributesSelector(store)
        };
      };
      var controllerActions = {
        fetchCodeType: MetadataActions.codes.fetchCodeTypes,
        searchOrders: searchOrders,
        stateGo: stateGo
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      if (this.state.hasOrderingAccess) {
        this.moreOptionsMenu = [this.addProductAction].filter(function (menuItem) {
          return menuItem.shouldShow();
        });
        if (!this.state.productClassificationsLoaded) {
          this.actions.fetchCodeType(MetadataConstants.codes.ProductClassification);
        }
      }
      this.isExpanded = true;
      this.showHoverActions = function (item) {
        return _this.hasAdminAccess && (!(item.Product && item.Product.Standalone && _this.state.businessUnitIsDbss) || pathOr('', ['Product', 'ProductClassification'], item) === PRODUCT_CLASSIFICATIONS.AD_HOC);
      };
      this.removeProductsPopupConfig = {
        onRegisterApi: function onRegisterApi(_ref) {
          var api = _ref.api;
          _this.removeProductsPopupConfig = api;
        }
      };
      this.multiClassErrorPopup = {
        onRegisterApi: function onRegisterApi(_ref2) {
          var api = _ref2.api;
          _this.multiClassErrorPopup = api;
        }
      };
      if (this.state.currentCustomerId) {
        this.actions.searchOrders(this.state.currentCustomerId);
      }
    }
  }, {
    key: "handleExpansion",
    value: function handleExpansion() {
      this.isExpanded = !this.isExpanded;
    }
  }, {
    key: "goToAddProductWizard",
    value: function goToAddProductWizard() {
      this.actions.stateGo(CREATE_PRODUCTS_ORDER_STATE_NAME, {
        productsOnly: true
      });
    }
  }, {
    key: "onMenuItemSelected",
    value: function onMenuItemSelected(selected) {
      return selected.item.callback();
    }
  }, {
    key: "getProductClassification",
    value: function getProductClassification(productClassificationId) {
      return pathOr(null, ['Name'], this.state.productClassifications.find(function (item) {
        return parseInt(item.Value, 10) === productClassificationId;
      }));
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }, {
    key: "getAdHocOverrideName",
    value: function getAdHocOverrideName(activeProduct) {
      var pricingPlanName = pathOr(null, ['PricingPlan', 'Name'], activeProduct);
      return pathOr(pricingPlanName, ['AdHocOverrideDetails', 'InvoiceText'], activeProduct);
    }
  }, {
    key: "getBriType",
    value: function getBriType(bri, productClass) {
      return productClass !== PRODUCT_CLASSIFICATIONS.AD_HOC ? bri.Name : i18n.translate(bri.Type === BILLER_RULE_INSTANCE_TYPE.RECURRING ? this.customerCareKeys.BILLER_RULE_INSTANCE_TYPES.RECURRING : this.customerCareKeys.BILLER_RULE_INSTANCE_TYPES.ONETIME);
    }
  }, {
    key: "closeRemoveProductsPopup",
    value: function closeRemoveProductsPopup() {
      this.removeProductsPopupConfig.close();
      this.showRemoveProductsPopup = false;
      this.resetSelectedItems();
    }
  }, {
    key: "closeMultiClassErrorPopup",
    value: function closeMultiClassErrorPopup() {
      this.multiClassErrorPopup.close();
    }
  }, {
    key: "openRemoveProductsPopup",
    value: function openRemoveProductsPopup(item) {
      var _this2 = this;
      this.selectedItems.push(item);
      this.showRemoveProductsPopup = true;
      this.$timeout(function () {
        _this2.removeProductsPopupConfig.open();
      });
    }
  }, {
    key: "submitRemoveProductsPopup",
    value: function submitRemoveProductsPopup() {
      this.closeRemoveProductsPopup();
      this.$state.reload();
      this.resetSelectedItems();
    }
  }, {
    key: "resetSelectedItems",
    value: function resetSelectedItems() {
      this.selectedItems = [];
    }
  }, {
    key: "discountTooltipText",
    value: function discountTooltipText(discounts) {
      return "".concat(discounts.length, " ").concat(i18n.translate(discounts.length === 1 ? CustomerLocaleKeys.DISCOUNT : CustomerLocaleKeys.DISCOUNTS_LABEL));
    }
  }]);
}();
export default {
  template: require('./active.products.html'),
  bindings: {
    customerId: '<',
    hasAdminAccess: '<'
  },
  controller: ActiveProductsController,
  controllerAs: 'ActiveProductsWidget'
};